import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ddt from '@wix/da-ddt';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import FullscreenIcon from '@wix/da-ds/pkg/Icons/24x24/FullView';
import FormatBubbleMenu from '../../../menus/FormatBubbleMenu';
import EverythingMenu from '../../../menus/EverythingMenu/EverythingMenu';
import UniversalMobileMenu from '../../../menus/UniversalMobileMenu';
import PluginInsertMenu from '../../../menus/PluginInsertMenu';
import Viewer from '../../../Viewer/presets/Commission';
import { isTouch } from '../../../utils/browser';
import EditorIconButton from '../../../menus/_partials/EditorIconButton';
import Editor from '../../Editor';
import FullscreenEditor from '../Fullscreen/Fullscreen';
import { extConfig, extConfigFullscreen } from './config';
import s from './Commission.scss';
import presetViewerStyles from '../../../Viewer/presets/Commission/Commission.scss';
const logger = ddt.createLogger('tiptapeditor');
function isTextEmpty(json) {
    if (!json) {
        return true;
    }
    if (json.hasOwnProperty('content') && !(json === null || json === void 0 ? void 0 : json.content)) {
        return true;
    }
    if (json === null || json === void 0 ? void 0 : json.html) {
        var _json_html, _json_html1;
        if (((_json_html = json.html) === null || _json_html === void 0 ? void 0 : _json_html.features) && /"isEmpty":true/.test((_json_html1 = json.html) === null || _json_html1 === void 0 ? void 0 : _json_html1.features)) {
            return true;
        }
    }
    return false;
}
const CommissionEditor = (props)=>{
    logger.log('CommissionEditor, props', JSON.stringify(props));
    const isMobile = useContext(MobileContext);
    const shouldUseMobileLayout = isMobile || isTouch();
    const { t } = useTranslation('editor');
    if (shouldUseMobileLayout) {
        return /*#__PURE__*/ React.createElement(FullscreenEditor, {
            modalProps: {
                contentClassName: s['fullscreen-bg'],
                heading: t('preset.commission.fullscreen.heading')
            }
        }, (currentContent, isFullscreen, toggleFs, scrollRef)=>{
            var _currentContent_doc, _currentContent_doc1, _currentContent_doc2;
            return /*#__PURE__*/ React.createElement("div", {
                className: cn(s['wrapper'], isFullscreen && s['fullscreen'], shouldUseMobileLayout && s['mobile'])
            }, !isFullscreen && /*#__PURE__*/ React.createElement("div", {
                className: s['viewer'],
                onClick: toggleFs
            }, isTextEmpty((_currentContent_doc = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc !== void 0 ? _currentContent_doc : props.initialContent) && /*#__PURE__*/ React.createElement("p", {
                className: s['fake-placeholder']
            }, t('preset.commission.placeholder')), /*#__PURE__*/ React.createElement(Viewer, _object_spread({
                className: s['viewer-inner'],
                contentJson: (_currentContent_doc1 = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc1 !== void 0 ? _currentContent_doc1 : props.initialContent
            }, props))), isFullscreen && /*#__PURE__*/ React.createElement("div", {
                className: cn(s['stuck'])
            }, /*#__PURE__*/ React.createElement(UniversalMobileMenu, null)), isFullscreen && /*#__PURE__*/ React.createElement("div", {
                className: cn(s['fixed-wrapper'])
            }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
                withinModal: true,
                presetId: "commission",
                className: s['root'],
                extensionConfig: isFullscreen ? extConfigFullscreen : extConfig,
                initialContent: (_currentContent_doc2 = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc2 !== void 0 ? _currentContent_doc2 : props.initialContent,
                initialSelection: currentContent === null || currentContent === void 0 ? void 0 : currentContent.selection,
                scrollContainerRef: scrollRef,
                autoScrollWhenWithin: 50,
                placeholder: t('preset.commission.placeholder')
            }), (_, scrollContainer)=>/*#__PURE__*/ React.createElement(React.Fragment, null, !isFullscreen && /*#__PURE__*/ React.createElement(FormatBubbleMenu, {
                    scrollContainerRef: scrollContainer
                })))));
        });
    }
    return /*#__PURE__*/ React.createElement(FullscreenEditor, {
        modalProps: {
            contentClassName: s['fullscreen-bg'],
            heading: t('preset.commission.fullscreen.heading')
        }
    }, (currentContent, isFullscreen, toggleFs, scrollRef)=>{
        var _currentContent_doc;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isFullscreen && /*#__PURE__*/ React.createElement("div", {
            className: cn(s['stuck'])
        }, /*#__PURE__*/ React.createElement(EverythingMenu, {
            wrapping: false
        })), /*#__PURE__*/ React.createElement("div", {
            className: cn(isFullscreen && s['fixed-wrapper'])
        }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
            withinModal: true,
            presetId: "commission",
            className: cn(s['editor'], presetViewerStyles['root'], !isFullscreen && s['in-form']),
            extensionConfig: isFullscreen ? extConfigFullscreen : extConfig,
            initialContent: (_currentContent_doc = currentContent === null || currentContent === void 0 ? void 0 : currentContent.doc) !== null && _currentContent_doc !== void 0 ? _currentContent_doc : props.initialContent,
            initialSelection: isFullscreen && !isTouch() && (currentContent === null || currentContent === void 0 ? void 0 : currentContent.selection),
            selfScrollContainer: !isFullscreen,
            scrollContainerRef: isFullscreen ? scrollRef : undefined,
            autoScrollWhenWithin: 50,
            placeholder: t('preset.commission.placeholder')
        }), (_, scrollContainer)=>/*#__PURE__*/ React.createElement(React.Fragment, null, !isFullscreen && /*#__PURE__*/ React.createElement(FormatBubbleMenu, {
                scrollContainerRef: scrollContainer
            })))), !isFullscreen && /*#__PURE__*/ React.createElement("div", {
            className: cn(s['toolbar'])
        }, /*#__PURE__*/ React.createElement(PluginInsertMenu, null), /*#__PURE__*/ React.createElement(EditorIconButton, {
            icon: FullscreenIcon,
            onClick: toggleFs,
            tooltipText: t('button.fullscreen')
        })));
    });
};
CommissionEditor.displayName = 'CommissionEditor';
export default CommissionEditor;

//# sourceMappingURL=Commission.js.map